(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
(function() {
  if (!document.getElementById('bundle-builder')) return;
  var config = window.bundleBuilderConfig;
  var TIERS = config.discountTiers;
  var selectedProducts = new Map();

  var progressFill  = document.getElementById('bundleProgressFill');
  var progressLabel = document.getElementById('bundleProgressLabel');
  var summaryList   = document.getElementById('bundleSummaryList');
  var countEl       = document.getElementById('bundleCount');
  var subtotalEl    = document.getElementById('bundleSubtotal');
  var discountRow   = document.getElementById('bundleDiscountRow');
  var discountLabel = document.getElementById('bundleDiscountLabel');
  var discountAmtEl = document.getElementById('bundleDiscountAmount');
  var totalEl       = document.getElementById('bundleTotal');
  var addToCartBtn  = document.getElementById('bundleAddToCart');
  var ctaTextEl     = document.getElementById('bundleCtaText');
  var hintEl        = document.getElementById('bundleHint');
  var noResultsEl   = document.getElementById('bundleNoResults');
  var filterBtns    = document.querySelectorAll('.bb__filter-btn');

  function formatMoney(cents) {
    var format = 'Rs. AMOUNT';
    try {
      if (config.moneyFormatEncoded) {
        format = decodeURIComponent(escape(atob(config.moneyFormatEncoded)));
      }
    } catch(e) {}
    var amount = (cents / 100).toFixed(2);
    var amountND = String(Math.round(cents / 100));
    return format
      .replace(/\{\{[\s]*amount[\s]*\}\}/g, amount)
      .replace(/\{\{[\s]*amount_no_decimals[\s]*\}\}/g, amountND)
      .replace(/\{\{[\s]*amount_with_comma_separator[\s]*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{[\s]*amount_no_decimals_with_comma_separator[\s]*\}\}/g, amountND.replace('.', ','));
  }

  function getActiveTier() {
    var count = selectedProducts.size;
    var active = null;
    for (var i = 0; i < TIERS.length; i++) {
      if (count >= TIERS[i].minItems) active = TIERS[i];
    }
    return active;
  }

  function applyFilter(handle) {
    var cards = document.querySelectorAll('.bb__card');
    var visible = 0;
    cards.forEach(function(card) {
      var col = card.dataset.collection || 'all';
      var show = handle === 'all' || col === handle;
      card.classList.toggle('is-hidden', !show);
      if (show) visible++;
    });
    if (noResultsEl) noResultsEl.style.display = visible === 0 ? 'block' : 'none';
  }

  filterBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      filterBtns.forEach(function(b) {
        b.classList.remove('bb__filter-btn--active');
        b.setAttribute('aria-selected', 'false');
      });
      btn.classList.add('bb__filter-btn--active');
      btn.setAttribute('aria-selected', 'true');
      applyFilter(btn.dataset.collection);
    });
  });

  function updateProgress() {
    var count = selectedProducts.size;
    var maxTier = TIERS[TIERS.length - 1];
    var pct = Math.min((count / maxTier.minItems) * 100, 100);
    progressFill.style.width = pct + '%';

    document.querySelectorAll('.bb__progress-gem').forEach(function(gem, i) {
      gem.classList.toggle('is-lit', count > i);
    });

    if (count === 0) {
      progressLabel.innerHTML = 'Add <strong>' + TIERS[0].minItems + ' pieces</strong> to unlock <strong>' + Math.round(TIERS[0].discount * 100) + '% off</strong>';
    } else if (count < TIERS[0].minItems) {
      var rem = TIERS[0].minItems - count;
      progressLabel.innerHTML = 'Add <strong>' + rem + ' more piece' + (rem > 1 ? 's' : '') + '</strong> to unlock <strong>' + Math.round(TIERS[0].discount * 100) + '% off</strong>';
    } else if (count < maxTier.minItems) {
      var nextTier = null;
      for (var i = 0; i < TIERS.length; i++) {
        if (TIERS[i].minItems > count) { nextTier = TIERS[i]; break; }
      }
      if (nextTier) {
        var remNext = nextTier.minItems - count;
        progressLabel.innerHTML = '✦ <strong>' + Math.round(getActiveTier().discount * 100) + '% off</strong> applied — add <strong>' + remNext + ' more</strong> for <strong>' + Math.round(nextTier.discount * 100) + '% off</strong>';
      }
    } else {
      progressLabel.innerHTML = '✦ Maximum <strong>' + Math.round(maxTier.discount * 100) + '% bundle discount</strong> unlocked!';
    }
  }

  function updateSummary() {
    var count = selectedProducts.size;
    var tier = getActiveTier();
    if (countEl) countEl.textContent = count + (count === 1 ? ' piece' : ' pieces');
    summaryList.innerHTML = '';

    if (count === 0) {
      summaryList.innerHTML = '<li class="bb__summary-empty">Your bundle is empty — select pieces above.</li>';
      subtotalEl.textContent = '—';
      discountRow.style.display = 'none';
      totalEl.textContent = '—';
      addToCartBtn.disabled = true;
      hintEl.textContent = 'Select at least 2 pieces to build your bundle.';
      return;
    }

    var subtotal = 0;
    selectedProducts.forEach(function(item) {
      subtotal += item.price;
      var li = document.createElement('li');
      li.innerHTML = '<span class="item-name">' + item.title + '</span><span class="item-price">' + formatMoney(item.price) + '</span>';
      summaryList.appendChild(li);
    });

    subtotalEl.textContent = formatMoney(subtotal);

    if (tier) {
      var saving = Math.round(subtotal * tier.discount);
      discountLabel.textContent = tier.label;
      discountAmtEl.textContent = '− ' + formatMoney(saving);
      discountRow.style.display = 'flex';
      totalEl.textContent = formatMoney(subtotal - saving);
      hintEl.textContent = 'You\'re saving ' + formatMoney(saving) + ' with this bundle!';
    } else {
      discountRow.style.display = 'none';
      totalEl.textContent = formatMoney(subtotal);
      var needed = TIERS[0].minItems - count;
      hintEl.textContent = 'Add ' + needed + ' more piece' + (needed > 1 ? 's' : '') + ' to unlock your discount.';
    }

    addToCartBtn.disabled = count < 2;
  }

  function updateCardPrices() {
    var tier = getActiveTier();
    document.querySelectorAll('.bb__card.is-selected').forEach(function(card) {
      var orig = parseInt(card.dataset.productPrice, 10);
      var saleEl = card.querySelector('.bb__card-price-sale');
      if (tier && saleEl) {
        saleEl.textContent = formatMoney(Math.round(orig * (1 - tier.discount)));
        saleEl.style.display = 'inline';
      } else if (saleEl) {
        saleEl.style.display = 'none';
      }
    });
    document.querySelectorAll('.bb__card:not(.is-selected)').forEach(function(card) {
      var saleEl = card.querySelector('.bb__card-price-sale');
      if (saleEl) saleEl.style.display = 'none';
    });
  }

  function toggleProduct(card) {
    var productId = card.dataset.productId;
    var variantSelect = card.querySelector('.bb__variant-select');
    var variantId = variantSelect ? variantSelect.value : card.dataset.variantId;
    var price = variantSelect
      ? parseInt((variantSelect.selectedOptions[0] && variantSelect.selectedOptions[0].dataset.price) || card.dataset.productPrice, 10)
      : parseInt(card.dataset.productPrice, 10);
    var title = card.dataset.productTitle;
    var btn = card.querySelector('.bb__card-btn');
    var addLbl = btn.querySelector('.bb__card-btn-add');
    var remLbl = btn.querySelector('.bb__card-btn-remove');

    if (selectedProducts.has(productId)) {
      selectedProducts.delete(productId);
      card.classList.remove('is-selected');
      btn.setAttribute('aria-pressed', 'false');
      addLbl.style.display = '';
      remLbl.style.display = 'none';
    } else {
      selectedProducts.set(productId, { variantId: variantId, price: price, title: title });
      card.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
      addLbl.style.display = 'none';
      remLbl.style.display = '';
    }

    updateProgress();
    updateCardPrices();
    updateSummary();
  }

  document.querySelectorAll('.bb__card').forEach(function(card) {
    card.querySelector('.bb__card-btn').addEventListener('click', function() {
      toggleProduct(card);
    });

    var variantSelect = card.querySelector('.bb__variant-select');
    if (variantSelect) {
      variantSelect.addEventListener('change', function() {
        var newVariantId = this.value;
        var newPrice = parseInt((this.selectedOptions[0] && this.selectedOptions[0].dataset.price) || card.dataset.productPrice, 10);
        card.dataset.variantId = newVariantId;
        card.dataset.productPrice = newPrice;
        var productId = card.dataset.productId;
        if (selectedProducts.has(productId)) {
          var existing = selectedProducts.get(productId);
          existing.variantId = newVariantId;
          existing.price = newPrice;
          updateCardPrices();
          updateSummary();
        }
      });
    }
  });

  addToCartBtn.addEventListener('click', function() {
    if (selectedProducts.size < 2) return;
    ctaTextEl.textContent = 'Adding to Cart…';
    addToCartBtn.disabled = true;
    var tier = getActiveTier();
    var items = [];
    selectedProducts.forEach(function(item) {
      items.push({
        id: parseInt(item.variantId, 10),
        quantity: 1,
        properties: {
          '_bundle': 'true',
          '_bundle_discount': tier ? Math.round(tier.discount * 100) + '%' : '0%',
          '_bundle_original_price': (item.price / 100).toFixed(2)
        }
      });
    });

    var sectionsToFetch = ['cart-notification-product', 'cart-notification-button', 'cart-icon-bubble'];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: sectionsToFetch,
        sections_url: window.location.pathname
      })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Cart error');
      return res.json();
    })
    .then(function(data) {
      ctaTextEl.textContent = '✓ Added to Cart';
      addToCartBtn.style.background = '#2d6a2d';
      addToCartBtn.style.color = '#fff';

      var parser = new DOMParser();

      // Update cart count bubble directly
      if (data.sections && data.sections['cart-icon-bubble']) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          var parsedBubble = parser.parseFromString(data.sections['cart-icon-bubble'], 'text/html');
          var bubbleSection = parsedBubble.querySelector('.shopify-section');
          if (bubbleSection) bubble.innerHTML = bubbleSection.innerHTML;
        }
      }

      // Trigger cart notification popup
      var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartEl && data.items && data.items.length > 0) {
        data.key = data.items[0].key;
        try {
          cartEl.renderContents(data);
        } catch (e) {
          // renderContents failed (missing section HTML) — open the popup directly
          // and manually update each section we do have HTML for
          if (data.sections) {
            sectionsToFetch.forEach(function(id) {
              if (!data.sections[id]) return;
              var el = document.getElementById(id);
              if (!el) return;
              var parsedSec = parser.parseFromString(data.sections[id], 'text/html');
              var sec = parsedSec.querySelector('.shopify-section');
              if (sec) el.innerHTML = sec.innerHTML;
            });
          }
          if (cartEl.open) cartEl.open();
        }
      }

      setTimeout(function() {
        ctaTextEl.textContent = 'Add Bundle to Cart';
        addToCartBtn.style.background = '';
        addToCartBtn.style.color = '';
        addToCartBtn.disabled = false;
      }, 2500);
    })
    .catch(function() {
      ctaTextEl.textContent = 'Error — Please Try Again';
      addToCartBtn.style.background = '#6a2d2d';
      addToCartBtn.style.color = '#fff';
      addToCartBtn.disabled = false;
    });
  });

  updateSummary();
  updateProgress();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-liquid"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-premium"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
